import { connect, RenderingSDK, EnvType } from '@rendering/web-client';
import { apiPrefix } from 'src/settings';

let sdk: RenderingSDK | null = null;

/**
 * Initialize the rendering SDK with authentication token
 * @param token - Authentication token from auth service
 * @returns Promise resolving to SDK instance
 */
export async function initSdk(token: string): Promise<RenderingSDK> {
    const env = apiPrefix === 'api.' ? EnvType.Prod : EnvType.Dev;
    sdk = await connect({ env, authToken: token });
    console.log('Rendering SDK initialized');
    return sdk;
}

/**
 * Get the current SDK instance
 * @returns SDK instance
 * @throws Error if SDK not initialized
 */
export function getSdk(): RenderingSDK {
    if (!sdk) {
        throw new Error('Rendering SDK not initialized. Call initSdk first.');
    }
    return sdk;
}
